import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { executeCarryAPI, getCarryJobAPI, getCarryTargetsAPI, previewCarryAPI } from '../api/coachCarry';
import { CarryRequest } from '../types/coachCarry';
import { publicMemberKeys } from '../features/publicMember/keys';

export const useCarryTargets = (centerId: string, coachId: string, accessToken: string, actorId: string) => useQuery({
    queryKey: ['coachCarryTargets', centerId, coachId, actorId],
    queryFn: () => getCarryTargetsAPI(centerId, coachId, accessToken),
    enabled: !!centerId && !!coachId && !!accessToken,
    retry: false,
    cacheTime: 0,
});

export const useCoachCarryService = (centerId: string, coachId: string, accessToken: string) => {
    const queryClient = useQueryClient();
    const preview = useMutation({
        mutationFn: (toCenterId: string) => previewCarryAPI(centerId, coachId, toCenterId, accessToken),
        retry: false,
    });
    const execute = useMutation({
        mutationFn: (body: CarryRequest) => executeCarryAPI(centerId, coachId, body, accessToken),
        retry: false,
        onSuccess: () => {
            // 응답을 잃거나 일부만 완료돼도 기존 화면은 서버에서 다시 확인한다.
            [
                'getEmployeeInfoAtManageAPIQuery', 'getTrainerListAPI', 'getUnpaidPaymentsQuery',
                'getAllMembershipForMemberQuery', 'getMembershipForMemberQuery', 'getMembershipTemplatesListAPI',
                'membershipChangeLog',
            ].forEach((key) => queryClient.invalidateQueries({ queryKey: [key] }));
            queryClient.invalidateQueries({ queryKey: publicMemberKeys.list(centerId) });
            queryClient.invalidateQueries({ queryKey: ['memberCoach'] });
        },
    });
    const job = useMutation({
        mutationFn: (jobId: string) => getCarryJobAPI(centerId, jobId, accessToken),
        retry: false,
    });
    return { preview, execute, job };
};
